{
  "element_add_emoji": "Add emoji",
  "add_comment_to_your_answer": "Add comment to your answer",
  "ai_feature_description": "Use AI to summarize responses and highlight key insights",
  "ai_feature_title": "Surveys AI",
  "ai_summary_open_answer_description": "Here’s what stood out in the responses",
  "all_set_and_ready_description": "Invitations will be sent, users will start to answer.",
  "all_set_and_ready_schedule_description": "Invitations will be sent on schedule.",
  "all_set_and_ready_schedule_title": "All is set and ready to go.\nLaunch later as planned?",
  "all_set_and_ready_title": "All is set and ready to go.\nLets start your survey right now?",
  "allow_multiple_selection": "Allow multiple selection",
  "allow_other_option": "Allow other option",
  "anonymous_file_warning_description": "File names or file contents may identify respondents. Review file questions before launching an anonymous survey.",
  "anonymous_file_warning_title": "File questions may compromise anonymity",
  "anonymous_participated": "Anonymous participation",
  "anonymous_threshold": "Number of answers to unveil results",
  "anonymous_threshold_min_value": "Minimum value is 3",
  "answer_anonymously": "Answer anonymously",
  "answers_breakdown": "Answers breakdown",
  "app_notification_title": "Please complete the survey",
  "complete_survey": "Complete survey",
  "complete_survey_confirm": "After completion, you will receive the final statistics and employees will no longer be able to participate in the survey.",
  "complete_survey_question": "Do you want to complete the survey?",
  "create_scale": "Create scale",
  "create_survey": "Create survey",
  "create_survey_template": "Create survey template",
  "create_template": "Create template",
  "delete_from_item_question": "Do you want to delete this item?",
  "delete_scale": "Delete scale",
  "delete_template": "Delete template",
  "do_not_use_emoji": "Don't use hero emoji for this survey",
  "duplicate_survey": "Duplicate survey",
  "duplicate_survey_confirm": "Are you sure you want to duplicate this survey? A new survey will be created as a draft.",
  "duplicate_template": "Duplicate template",
  "duplicate_template_confirm": "Are you sure you want to duplicate this template?",
  "duplicate_template_in_performance_reviews": "Duplicate in performance reviews",
  "duplicate_template_in_performance_reviews_confirm": "A copy of this template will be created in performance reviews",
  "duplicate_template_in_surveys": "Duplicate in surveys",
  "duplicate_template_in_surveys_confirm": "A copy of this template will be created in surveys",
  "edit_question": "Edit question",
  "edit_scale": "Edit scale",
  "edit_survey": "Edit survey",
  "element_without_emoji": "Without emoji",
  "file_answer_anonymous_warning_description": "The file name or its contents may reveal your identity",
  "file_answer_anonymous_warning_title": "This file may compromise anonymity",
  "file_upload_button": "Upload files",
  "file_upload_count_error": "You can attach up to {count} files",
  "file_upload_limits": "Up to {count} files, {size} MB each",
  "file_upload_remove": "Remove file",
  "file_upload_server_error": "The file could not be uploaded. Try again",
  "file_upload_size_error": "The file must not exceed {size} MB",
  "file_upload_title": "Files",
  "file_result_empty": "No files attached",
  "file_result_open_error": "The file could not be opened. Try again",
  "employee_nps_breakdown": "Scores under 9 need improvement, 10-30 are good, 31-100 are excellent",
  "employee_nps_element_description_default": "Rate your likelihood from 0 (not at all) to 10 (absolutely)",
  "employee_nps_element_title_default": "Would you recommend our company as a place to work?",
  "employee_nps_extremely_likely": "Extremely likely",
  "employee_nps_not_at_all_likely": "Not at all likely",
  "employee_nps_promoters": "Promoters",
  "employee_nps_passives": "Passives",
  "employee_nps_detractors": "Detractors",
  "employee_nps_score_label": "NPS score {score}",
  "employee_nps_rating_excellent": "Excellent",
  "employee_nps_rating_good": "Good",
  "employee_nps_rating_needs_improvement": "Needs improvement",
  "employee_nps_how_measured": "How NPS is measured?",
  "employee_nps_range_negative": "-100 ... -1 Needs improvement",
  "employee_nps_range_good": "0 ... 30 Good",
  "employee_nps_range_excellent": "31 ... 100 Excellent",
  "employee_nps_tab_by_department": "By department",
  "employee_nps_tab_by_manager": "By manager",
  "employee_nps_tab_score_distribution": "Score distribution",
  "filtered_by_manager": "Filtered by manager: {name}",
  "filtered_by_managers": "Filtered by managers: {names}",
  "filtered_by_department": "Filtered by department: {name}",
  "filtered_by_departments": "Filtered by departments: {names}",
  "employee_nps_results_negative_description": "Many employees are not ready to recommend your company",
  "employee_nps_results_negative_title": "Your team’s eNPS is {score} — needs attention",
  "employee_nps_results_neutral_description": "Employees are unsure about recommending your company",
  "employee_nps_results_neutral_title": "Your team’s eNPS is {score} — neutral sentiment",
  "employee_nps_results_positive_description": "Most employees would recommend your company to others",
  "employee_nps_results_positive_title": "Your team’s eNPS is {score} — positive sentiment",
  "employee_surveys_empty_state_description": "Once surveys are available, you will see them here",
  "employee_surveys_empty_state_title": "No surveys yet",
  "empty_state_scales_description": "Make it easy for your team to give clear, structured ratings.\nDefine scales once and reuse them across all your surveys.",
  "empty_state_scales_title": "Build your first rating scale",
  "empty_state_survey_templates_description": "Templates help you build consistent surveys faster by reusing common questions and settings.\nStart here to save time and make sure every survey meets your company’s standards.",
  "empty_state_survey_templates_title": "Create your first survey template",
  "go_to_survey": "Go to survey",
  "invitation_description": "Write a custom email inviting participants to the survey.",
  "invite_co_owners_description": "They will be able to modify survey like you, except of inviting other co-owners",
  "invite_co_owners_title": "Invite co-owners",
  "launch_on_schedule": "Launch on schedule",
  "launch_survey": "Launch survey",
  "make_anonymous": "Make anonymous",
  "manage": "Manage",
  "my_surveys": "My surveys",
  "no_elements_in_survey_empty_state_description": "Choose from scale, text, single or multiple choice options or employee NPS",
  "no_elements_in_survey_empty_state_title": "Start by adding your first question",
  "participant_completed_label": "{count} Completed",
  "participant_status_added": "Added",
  "participant_status_canceled": "Canceled",
  "participant_status_completed": "Completed",
  "participant_status_in_progress": "In progress",
  "participant_status_invited": "Invited",
  "participants_empty_state_description": "To invite employees, go to survey editing",
  "participants_empty_state_title": "Add participants to your survey",
  "participants_rules_description": "Select who will be invited to answer the survey.",
  "participants_waiting": "Waiting",
  "pause_survey": "Pause survey",
  "permissions_form_scales_edit_description": "Create, edit, and view all rating scales",
  "permissions_form_scales_title": "Scales",
  "permissions_form_scales_view_description": "Choose from existing rating scales when creating surveys",
  "permissions_survey_templates_edit_description": "Create, modify, and manage survey templates for the organization",
  "permissions_survey_templates_none_description": "Cannot view or use any survey templates",
  "permissions_survey_templates_title": "Survey templates",
  "permissions_survey_templates_view_description": "See existing templates without making changes",
  "permissions_surveys_create": "Create new surveys",
  "permissions_surveys_create_description": "Allow to build surveys for employees",
  "permissions_surveys_manage_all": "Manage existing surveys",
  "permissions_surveys_manage_all_description": "Edit, schedule, or delete any survey in the system",
  "question_comment_enabled": "Comment enabled",
  "question_mandatory": "Mandatory question",
  "question_title": "Question title",
  "question_type_employee_nps": "Employee NPS",
  "question_type_employee_nps_caption": "Measure satisfaction",
  "question_type_file": "File",
  "question_type_file_caption": "Let respondents attach a file",
  "question_type_goal": "Goal evaluation",
  "question_type_goal_caption": "Evaluate progress and completion",
  "question_type_open_answer": "Open answer",
  "question_type_open_answer_caption": "Answer in free text",
  "question_type_page_caption": "Create a new page",
  "question_type_scale": "Scale",
  "question_type_scale_caption": "Rate on a numeric or labeled scale",
  "question_type_section_caption": "Add a section heading",
  "question_type_select": "Multiple choice",
  "question_type_select_caption": "Select one or more options",
  "question_type_text": "Text",
  "question_type_text_caption": "Add plain text",
  "question_type_text_full": "Text block",
  "reopen_survey": "Reopen survey",
  "reopen_survey_confirm": "The survey will be reopened and employees will be able to continue participating.",
  "reopen_survey_question": "Do you want to reopen the survey?",
  "request_closed_description": "This request can no longer be filled in.",
  "request_closed_title": "Request closed",
  "request_fill": "Fill in request",
  "request_notification_title": "Fill in your request",
  "request_submitted_description": "We have sent it for approval.",
  "request_submitted_title": "Request submitted",
  "responses": "Responds",
  "responses_description": "{people_answered} to the survey. We only show fully completed results",
  "result_not_available_yet_description": "This is an anonymous survey. To protect privacy, results will be shown when enough responses are collected",
  "result_not_available_yet_title": "Results not available yet",
  "review_date_ends_at": "Survey end date",
  "save_as_draft": "Save as draft",
  "save_as_template": "Save as template",
  "scale": "Scale",
  "scale_type_double_scale": "Double scale",
  "scale_type_single_scale": "Single scale",
  "scales": "Scales",
  "select_scale": "Select scale",
  "select_template_description": "Choose an existing template or create a new one to build your survey",
  "select_template_title": "Select survey template",
  "share_after_completion_description": "Selected people will see the results once the survey is marked as finished",
  "share_after_completion_title": "Share only when survey is completed",
  "share_specific_people_description": "They will be able to access survey results, but will not be able to modify survey.",
  "share_specific_people_title": "Share results with specific people",
  "start_from_scratch": "Start from scratch",
  "start_from_scratch_confirm": "This will delete your current setup. You can start with a blank form or choose a template",
  "start_from_scratch_description": "Create new set of questions",
  "start_from_scratch_title": "Start from scratch",
  "start_over": "Start over",
  "start_survey": "Take part",
  "survey": "Survey",
  "survey_history": "Survey history",
  "survey_history_empty_state_description": "Completed surveys will appear here",
  "survey_history_empty_state_title": "No survey history yet",
  "survey_status": "Survey status",
  "survey_closed_description": "This survey is no longer accepting responses.",
  "survey_completed_description": "Your responses have been submitted. Thank you for your participation.",
  "survey_completed_title": "Survey completed",
  "survey_has_been_updated_description": "All changes have been saved successfully",
  "survey_has_been_updated_title": "Your survey has been updated",
  "survey_share_title": "Privacy & co-owners",
  "survey_template": "Survey template",
  "surveys": "Surveys",
  "surveys_empty_state_description": "Find out what really matters to your team.\n Ask the right questions, get honest answers, and use the results to make work better for everyone",
  "surveys_empty_state_title": "Start your first survey",
  "surveys_feature_description": "Collect employee feedback and measure engagement with customizable forms",
  "surveys_module": "Access survey system",
  "surveys_module_description": "Required for all survey interactions.",
  "surveys_notification_description": "New surveys to complete or survey results available",
  "template_saved": "Template saved",
  "use_ai_description": "Generate automatic insights from survey answers",
  "use_ai_title": "Use AI to analyze responses",
  "write_to_field_all_columns": "All columns in table",
  "write_to_field_add_another": "Add another",
  "write_to_field_caption": "Save responses directly to profile",
  "write_to_field_columns_title": "Columns to fill",
  "write_to_field_destination_placeholder": "Destination",
  "write_to_field_destination_title": "Respondent will be asked to fill in",
  "write_to_field_entry_title": "Entry {number}",
  "write_to_field_group_tables": "Tables",
  "write_to_field_mode_create_multiple": "Create multiple",
  "write_to_field_mode_create_multiple_caption": "Allow create multiple entries",
  "write_to_field_mode_create_new": "Create new",
  "write_to_field_mode_create_new_caption": "Only one record allowed",
  "write_to_field_mode_update_existing": "Update existing",
  "write_to_field_mode_update_existing_caption": "Allow to edit existing data",
  "write_to_field_results_destination": "Responses saved to Employee profile → {target}",
  "write_to_field_show_current_row": "Show the current value",
  "write_to_field_show_current_row_title": "Should the current value be displayed?",
  "write_to_field_table_mode_title": "What should be done with the data?",
  "write_to_field_title": "Save to field",
  "write_to_field_view_responses_after_link": "tab",
  "write_to_field_view_responses_before_link": "View individual responses in the",
  "~": "~"
}
